import React from "react";

const NiStar = ({ color = "#D9D9D9", size = 20 }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                color,
            }}
        >
            <path
                d="M11.1264 2.56801C11.5077 1.8836 12.4923 1.8836 12.8736 2.56801L15.3388 6.99292C15.4771 7.24114 15.7144 7.41881 15.9916 7.48155L20.846 8.58054C21.58 8.74671 21.8743 9.63349 21.3854 10.2056L18.03 14.1315C17.8536 14.3379 17.7687 14.6072 17.7949 14.8776L18.2978 20.0704C18.3722 20.8387 17.5851 21.398 16.884 21.075L12.4184 19.0178C12.1529 18.8954 11.8471 18.8954 11.5816 19.0178L7.116 21.075C6.41494 21.398 5.62782 20.8387 5.70223 20.0704L6.20514 14.8776C6.23132 14.6072 6.14643 14.3379 5.96998 14.1315L2.61464 10.2056C2.1257 9.63349 2.42004 8.7467 3.15402 8.58054L8.00843 7.48155C8.28556 7.41881 8.52291 7.24114 8.6612 6.99292L11.1264 2.56801Z"
                fill={color}
                stroke={color}
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default NiStar;